// Meta Pixel custom events for the app download buttons and popups. The pixel
// itself is installed in layout.html's <head>; this only reports to it.
//
// The names are a closed list on purpose. `Lead` belongs to the Fieldstone
// campaign, so an app email must never be reported as one, and a typo here
// would quietly create a new event in Events Manager that no ad set uses.
export type MetaCustomEvent =
  | 'Download for Mac Clicked'
  | 'Download for Mac Tapped on Mobile'
  | 'App Link Requested'
  | 'Windows Waitlist Joined';

declare global {
  interface Window {
    fbq?: (command: string, ...args: unknown[]) => void;
  }
}

// The pixel is often ad-blocked; a missing fbq must never break a button.
export function trackMetaEvent(name: MetaCustomEvent, params?: Record<string, string>): void {
  if (typeof window.fbq === 'function') {
    window.fbq('trackCustom', name, params ?? {});
  }
}
